import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzUpdateAgentWebComponent } from './component/GzUpdateAgentWebComponent';
import { GzDialog } from '../../../../ui/gzDialog/component/GzDialog';
import { translateFn } from '../../../../utils/translator.helper';
import { CreateTaskRequest } from '../../types';
import { getFormattedDateForTask } from '../../../networkAppContainer/helpers/utils';
import { TaskType } from '../../../../tasks/networkTasks/types';

export class UpdateAgentPopUp extends NetworkBasePopUp<GzUpdateAgentWebComponent> {
  protected title = translateFn('Update agent');
  protected transformToTaskTarget = false;
  protected extraDialogConfigs: Partial<GzDialog> = {
    isWindow: true,
  };

  protected customSetup() {
    this.popUpContent = new GzUpdateAgentWebComponent();
    this.popUpContent.shouldDisableProductCheckbox = this.allTargetsAreProtectedBySecurityContainer();
    this.popUpFooterButtons = [
      {
        id: 'confirmButton',
        label: translateFn('Update#action'),
      },
    ];
  }

  protected async handleConfirmButtonClicked(event: CustomEvent) {
    const requestTargets = this.transformProtectedEntitiesToTargetEntities();
    const requestSpecifics = this.popUpContent.getRequestTaskSpecifics();

    const request: CreateTaskRequest = {
      settings: {
        specifics: requestSpecifics,
        targets: requestTargets,
        taskName: this.title + ` ${getFormattedDateForTask()}`,
        type: TaskType.TASK_TYPE_UPDATE_ENDPOINT_PARENT,
      },
    };

    await this.createTask(request);
  }

  private allTargetsAreProtectedBySecurityContainer() {
    return (
      this.data.targets?.filter(target => target.isProtectedBySecurityContainer).length === this.data.targets?.length
    );
  }
}
